
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34549',
  depVersions: {
  "documents-public-ui": "static-1.34549",
  "atom": "static-1.5083",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2507",
  "client-types": "static-1.466",
  "cssUtils": "static-1.794",
  "customer-data-filters-ui": "static-1.39834",
  "customer-data-objects": "static-1.7680",
  "customer-data-property-utils": "static-1.8101",
  "documents-lib": "static-1.34554",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.338",
  "FormsCommonComponents": "static-1.85888",
  "FormUrlGenerator": "static-2.4729",
  "foundations-theming-specialty": "static-1.2145",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5602",
  "hs-test-utils": "static-1.8024",
  "hub-http": "static-1.6232",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11789",
  "HubStyleTokens": "static-2.11482",
  "I18n": "static-7.1628",
  "icons": "static-2.648",
  "jasmine-immutable": "static-1.3032",
  "jasmine-runner": "static-1.6475",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7166",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5411",
  "quartz": "static-1.7047",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-feat-id-1323-initial-url.10",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5351",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8181",
  "reference-resolvers-lite": "static-1.8105",
  "reporting-data": "static-1.67603",
  "reporting-reports": "static-1.67281",
  "reporting-snowflake": "static-1.56221",
  "reporting-testing-lib": "static-1.9536",
  "reporting-visualizations": "static-1.59679",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8953",
  "sanitize": "static-1.4487",
  "sanitize-text": "static-1.8152",
  "self-service-api": "static-1.10258",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1758",
  "signup-constants": "static-1.18859",
  "signup-ui-url-generator": "static-2.8061",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4772",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4773",
  "ui-addon-form-validation": "static-1.11000",
  "ui-asset-management-lib": "static-1.11049",
  "ui-images": "static-2.1156",
  "UIComponents": "static-3.8428",
  "usage-tracker": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-container": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "viral-links-lib": "static-1.7074",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9679",
  "foundations-components": "static-1.7960",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.825",
  "quartz-core": "static-1.6266",
  "quick-fetch": "static-1.3923",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4663",
  "ui-addon-i18n": "static-1.11159",
  "ui-addon-upgrades": "static-9.18011",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3405",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3324",
  "quartz-webpack": "static-1.3271",
  "foundations-assets": "static-1.4877",
  "foundations-theming": "static-1.4429",
  "hub-http-shared-msw-handlers": "static-1.9991",
  "hubspotter-http": "static-1.4658",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.232",
  "conversations-skeleton-state": "static-1.7257",
  "crm-message-bus": "static-1.43029",
  "customer-data-filters-ui-msw-helpers": "static-1.22269",
  "customer-data-objects-ui-components": "static-1.13038",
  "customer-data-reference-ui-components": "static-1.13175",
  "customer-data-ui-utilities": "static-1.9837",
  "framework-builder-read-service-client": "static-1.4011",
  "framework-data-schema-quick-fetch": "static-1.6800",
  "framework-data-schema-resolvers": "static-1.6895",
  "inbound-db-meta-service-client": "static-1.3592",
  "inbound-db-properties-service-client": "static-1.3852",
  "multi-account-reference-resolvers": "static-1.990",
  "onboarding-tours": "static-1.16633",
  "reporting-datasets-permissions-lib": "static-1.13722",
  "ui-addon-teams": "static-1.21569",
  "quartz-auth": "static-1.722",
  "ui-business-units-lib": "static-1.9065",
  "usage-tracker-session-replay": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "ai-components-ui-library": "static-1.9013",
  "ContentUtils": "static-1.68403",
  "customer-data-properties": "static-1.51593",
  "forms-ai-lib": "static-1.4336",
  "forms-utils-lib": "static-1.12607",
  "foundations-components-test-utils": "static-1.5443",
  "react-dnd-compat": "static-1.4625",
  "react-tinymce": "static-1.55280",
  "tinymce-config": "static-2.54406",
  "ui-gdpr-components": "static-1.10361",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3414",
  "HeadJS": "static-2.762",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3135",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.87",
  "ui-fonts": "static-1.744",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4338",
  "csstype": "static-1.50",
  "quartz-head": "static-1.712",
  "web-vitals": "static-1.6",
  "batch-promise": "static-1.1552",
  "external-options-client-types": "static-1.4165",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.722",
  "frontend-preferences-client": "static-1.7938",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3709",
  "reporting-client-types": "static-1.2499",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25418",
  "hubspot-apollo-client": "static-1.4890",
  "foundations-components-legacy": "static-1.985",
  "merchandise-lib": "static-1.264",
  "quartz-routing": "static-1.477",
  "hs-story-utils": "static-1.9435",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.237",
  "timezone-utils": "static-2.5255",
  "seat-types-lib": "static-1.39",
  "bend-plugin-foundations-components": "static-1.4229",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1978",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.722",
  "quartz-tracking": "static-1.426",
  "bend-plugin-chirp-manifest": "static-1.73",
  "chirp-fetch": "static-1.1898",
  "purchase-motions-components": "static-1.5925",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4086",
  "bender-build-tools": "static-1.3205",
  "amplitude-session-replay-browser": "static-1.60",
  "bend-plugin-foundations-theming": "static-1.2912",
  "stylex": "static-1.33",
  "hs-resources": "static-1.162",
  "pulse": "static-1.585",
  "restore-request-side-panel-lib": "static-1.915",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3803",
  "crm-pipelines-api-client-types": "static-1.4145",
  "fdsr-migration-layer": "static-1.14",
  "multi-currency-client-types": "static-1.3697",
  "getting-started-shared-tasks": "static-1.18501",
  "growth-data-modal": "static-1.5446",
  "growth-onboarding-confetti": "static-1.3077",
  "growth-onboarding-next-action-utils": "static-1.1958",
  "navigation-components": "static-1.18073",
  "onboarding-tours-client": "static-1.4847",
  "onboarding-tours-utils": "static-1.699",
  "ui-shepherd-react": "static-3.10175",
  "ui-shepherd-tracker": "static-1.7556",
  "ui-universal-auth": "static-1.8991",
  "user-context": "static-1.5116",
  "hubspotter-http-shared-msw-handlers": "static-1.9989",
  "magpie-lib": "static-1.5558",
  "navigation-messaging": "static-1.7400",
  "chatspot-core": "static-1.21389",
  "copilot-toolkit": "static-1.11167",
  "cms-field-types": "static-1.4823",
  "content-icons-ui": "static-1.2229",
  "integrations-lib": "static-1.16188",
  "calling-global-api": "static-1.64552",
  "calling-internal-common": "static-1.31313",
  "calling-lifecycle-internal": "static-1.65934",
  "calling-lifecycle-messages": "static-1.58228",
  "commerce-products-lib": "static-1.9612",
  "crm-links": "static-1.6304",
  "customer-data-properties-shared-msw-handlers": "static-1.9318",
  "file-manager-components": "static-1.23659",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4229",
  "meetings-icalendar-utils-lib": "static-1.642",
  "object-builder-ui-client": "static-1.48788",
  "pipeline-validation-client-types": "static-1.3971",
  "property-value-citations": "static-1.2207",
  "smart-property-lib": "static-1.7131",
  "tiered-pricing": "static-1.1244",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9068",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19855",
  "tinymce-themes": "static-1.56376",
  "data-token-picker": "static-1.16429",
  "hub-http-contrib": "static-1.3053",
  "interframe": "static-3.4770",
  "tinymce-data": "static-1.40491",
  "tinymce-plugins": "static-1.57520",
  "ui-addon-sales-email": "static-1.5221",
  "onboarding-scopes": "static-1.6472",
  "ui-addon-opt": "static-4.8377",
  "apollo-link-hub-http": "static-2.4662",
  "hubspot-apollo-cache": "static-1.349",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.183",
  "purchase-motions-api": "static-1.5928",
  "trials-service-types": "static-1.3913",
  "bend-plugin-pulse": "static-1.88",
  "directed-graph": "static-1.946",
  "event-emitter": "static-1.958",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.1975",
  "growth-onboarding-next-action-components": "static-1.1986",
  "user-context-client": "static-1.4623",
  "idb-keyval": "static-1.44",
  "magpie-types": "static-1.5018",
  "nest": "static-1.237",
  "reactive-lib": "static-1.735",
  "simple-logging-lib": "static-1.3061",
  "unified-auth-core-lib": "static-1.787",
  "getting-started-shared-tasks-store": "static-1.17619",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13603",
  "integrations-tracking-lib": "static-1.5611",
  "native-integrations-shared-strings": "static-1.7792",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10376",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.505",
  "calling-error-reporting": "static-1.31320",
  "shared-worker-versioning": "static-1.11047",
  "calling-usage-tracker": "static-1.6552",
  "voice-sms-access-library": "static-1.1016",
  "customer-data-tracking": "static-1.6900",
  "commerce-permissions": "static-1.780",
  "products-iframe-lib": "static-1.7973",
  "products-ui-components-shared-msw-handlers": "static-1.10373",
  "location-customization-utils-lib": "static-1.9301",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4165",
  "video-components-external": "static-1.11315",
  "video-data-lib": "static-1.34973",
  "data-agent-kit": "static-1.211",
  "feedback-loader": "static-1.29315",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10074",
  "fsm": "static-1.3741",
  "policy-lib": "static-1.6788",
  "react-colorpicker": "static-2.10217",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10137",
  "FileManagerLib": "static-1.39299",
  "NamespacedHubStyle": "static-2.9065",
  "FileManagerCore": "static-1.39158",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7769",
  "layout-dnd-components": "static-1.12468",
  "layout-dnd-utils": "static-1.11443",
  "react-codemirror": "static-1.10637",
  "ui-addon-emoji-picker": "static-1.9898",
  "ui-brand-identity-lib": "static-1.15322",
  "InboxConnectUtils": "static-4.14850",
  "meetings-connect-utils-lib": "static-1.7616",
  "universal-page-editor-lib": "static-1.3023",
  "google-sheets-integration-lib": "static-1.277",
  "microsoft-drive-integration-lib": "static-1.395",
  "slack-ui-library": "static-1.10403",
  "calling-orchestration-schema": "static-1.35793",
  "sales-views-client-types": "static-1.4269",
  "crm-record-cards-service-types": "static-1.3603",
  "content-media-composition-data-lib": "static-1.12360",
  "content-media-compositions": "static-2.16367",
  "media-bridge-lib": "static-1.18948",
  "trellis-story-utils": "static-1.4526",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5931",
  "FileManagerImages": "static-1.36810",
  "video-components": "static-1.13318",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4547",
  "video-embed": "static-1.35807",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8713",
  "ui-coaching-tips": "static-1.28596",
  "ContentData": "static-1.68478",
  "layout-data-lib": "static-1.9768",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22151",
  "outpost": "static-1.4192",
  "growth-onboarding-feedback-components": "static-1.6591",
  "advanced-menus-core": "static-1.15145",
  "advanced-menus-lib": "static-1.12084",
  "ExportDialog": "static-6.10399",
  "ui-memberships-settings-lib": "static-1.34082",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15144",
  "simple-menus-lib": "static-1.16661"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34549",
  "atom": "/atom/static-1.5083",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2507",
  "client-types": "/client-types/static-1.466",
  "cssUtils": "/cssUtils/static-1.794",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39834",
  "customer-data-objects": "/customer-data-objects/static-1.7680",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8101",
  "documents-lib": "/documents-lib/static-1.34554",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.338",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85888",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4729",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2145",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5602",
  "hs-test-utils": "/hs-test-utils/static-1.8024",
  "hub-http": "/hub-http/static-1.6232",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11789",
  "HubStyleTokens": "/HubStyleTokens/static-2.11482",
  "I18n": "/I18n/static-7.1628",
  "icons": "/icons/static-2.648",
  "jasmine-immutable": "/jasmine-immutable/static-1.3032",
  "jasmine-runner": "/jasmine-runner/static-1.6475",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7166",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5411",
  "quartz": "/quartz/static-1.7047",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-feat-id-1323-initial-url.10",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5351",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8181",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8105",
  "reporting-data": "/reporting-data/static-1.67603",
  "reporting-reports": "/reporting-reports/static-1.67281",
  "reporting-snowflake": "/reporting-snowflake/static-1.56221",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9536",
  "reporting-visualizations": "/reporting-visualizations/static-1.59679",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8953",
  "sanitize": "/sanitize/static-1.4487",
  "sanitize-text": "/sanitize-text/static-1.8152",
  "self-service-api": "/self-service-api/static-1.10258",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1758",
  "signup-constants": "/signup-constants/static-1.18859",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8061",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4772",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4773",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11000",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11049",
  "ui-images": "/ui-images/static-2.1156",
  "UIComponents": "/UIComponents/static-3.8428",
  "usage-tracker": "/usage-tracker/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-container": "/usage-tracker-container/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "/usage-tracker-core/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "viral-links-lib": "/viral-links-lib/static-1.7074",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9679",
  "foundations-components": "/foundations-components/static-1.7960",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.825",
  "quartz-core": "/quartz-core/static-1.6266",
  "quick-fetch": "/quick-fetch/static-1.3923",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4663",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11159",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18011",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3405",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3324",
  "quartz-webpack": "/quartz-webpack/static-1.3271",
  "foundations-assets": "/foundations-assets/static-1.4877",
  "foundations-theming": "/foundations-theming/static-1.4429",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9991",
  "hubspotter-http": "/hubspotter-http/static-1.4658",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.232",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7257",
  "crm-message-bus": "/crm-message-bus/static-1.43029",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22269",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13038",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13175",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9837",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4011",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6800",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6895",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3592",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3852",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.990",
  "onboarding-tours": "/onboarding-tours/static-1.16633",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13722",
  "ui-addon-teams": "/ui-addon-teams/static-1.21569",
  "quartz-auth": "/quartz-auth/static-1.722",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9065",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9013",
  "ContentUtils": "/ContentUtils/static-1.68403",
  "customer-data-properties": "/customer-data-properties/static-1.51593",
  "forms-ai-lib": "/forms-ai-lib/static-1.4336",
  "forms-utils-lib": "/forms-utils-lib/static-1.12607",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5443",
  "react-dnd-compat": "/react-dnd-compat/static-1.4625",
  "react-tinymce": "/react-tinymce/static-1.55280",
  "tinymce-config": "/tinymce-config/static-2.54406",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10361",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3414",
  "HeadJS": "/HeadJS/static-2.762",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3135",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.87",
  "ui-fonts": "/ui-fonts/static-1.744",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4338",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.712",
  "web-vitals": "/web-vitals/static-1.6",
  "batch-promise": "/batch-promise/static-1.1552",
  "external-options-client-types": "/external-options-client-types/static-1.4165",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.722",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7938",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3709",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25418",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4890",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.985",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "quartz-routing": "/quartz-routing/static-1.477",
  "hs-story-utils": "/hs-story-utils/static-1.9435",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.237",
  "timezone-utils": "/timezone-utils/static-2.5255",
  "seat-types-lib": "/seat-types-lib/static-1.39",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4229",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1978",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.722",
  "quartz-tracking": "/quartz-tracking/static-1.426",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.73",
  "chirp-fetch": "/chirp-fetch/static-1.1898",
  "purchase-motions-components": "/purchase-motions-components/static-1.5925",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4086",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2912",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.162",
  "pulse": "/pulse/static-1.585",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.915",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3803",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4145",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.14",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3697",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18501",
  "growth-data-modal": "/growth-data-modal/static-1.5446",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3077",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1958",
  "navigation-components": "/navigation-components/static-1.18073",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4847",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.699",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10175",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7556",
  "ui-universal-auth": "/ui-universal-auth/static-1.8991",
  "user-context": "/user-context/static-1.5116",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9989",
  "magpie-lib": "/magpie-lib/static-1.5558",
  "navigation-messaging": "/navigation-messaging/static-1.7400",
  "chatspot-core": "/chatspot-core/static-1.21389",
  "copilot-toolkit": "/copilot-toolkit/static-1.11167",
  "cms-field-types": "/cms-field-types/static-1.4823",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "integrations-lib": "/integrations-lib/static-1.16188",
  "calling-global-api": "/calling-global-api/static-1.64552",
  "calling-internal-common": "/calling-internal-common/static-1.31313",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65934",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58228",
  "commerce-products-lib": "/commerce-products-lib/static-1.9612",
  "crm-links": "/crm-links/static-1.6304",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9318",
  "file-manager-components": "/file-manager-components/static-1.23659",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4229",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.642",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48788",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3971",
  "property-value-citations": "/property-value-citations/static-1.2207",
  "smart-property-lib": "/smart-property-lib/static-1.7131",
  "tiered-pricing": "/tiered-pricing/static-1.1244",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9068",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19855",
  "tinymce-themes": "/tinymce-themes/static-1.56376",
  "data-token-picker": "/data-token-picker/static-1.16429",
  "hub-http-contrib": "/hub-http-contrib/static-1.3053",
  "interframe": "/interframe/static-3.4770",
  "tinymce-data": "/tinymce-data/static-1.40491",
  "tinymce-plugins": "/tinymce-plugins/static-1.57520",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5221",
  "onboarding-scopes": "/onboarding-scopes/static-1.6472",
  "ui-addon-opt": "/ui-addon-opt/static-4.8377",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4662",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.349",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.183",
  "purchase-motions-api": "/purchase-motions-api/static-1.5928",
  "trials-service-types": "/trials-service-types/static-1.3913",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.88",
  "directed-graph": "/directed-graph/static-1.946",
  "event-emitter": "/event-emitter/static-1.958",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1975",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1986",
  "user-context-client": "/user-context-client/static-1.4623",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-types": "/magpie-types/static-1.5018",
  "nest": "/nest/static-1.237",
  "reactive-lib": "/reactive-lib/static-1.735",
  "simple-logging-lib": "/simple-logging-lib/static-1.3061",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.787",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17619",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13603",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5611",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7792",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10376",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.505",
  "calling-error-reporting": "/calling-error-reporting/static-1.31320",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11047",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6552",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1016",
  "customer-data-tracking": "/customer-data-tracking/static-1.6900",
  "commerce-permissions": "/commerce-permissions/static-1.780",
  "products-iframe-lib": "/products-iframe-lib/static-1.7973",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10373",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9301",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4165",
  "video-components-external": "/video-components-external/static-1.11315",
  "video-data-lib": "/video-data-lib/static-1.34973",
  "data-agent-kit": "/data-agent-kit/static-1.211",
  "feedback-loader": "/feedback-loader/static-1.29315",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10074",
  "fsm": "/fsm/static-1.3741",
  "policy-lib": "/policy-lib/static-1.6788",
  "react-colorpicker": "/react-colorpicker/static-2.10217",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10137",
  "FileManagerLib": "/FileManagerLib/static-1.39299",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9065",
  "FileManagerCore": "/FileManagerCore/static-1.39158",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7769",
  "layout-dnd-components": "/layout-dnd-components/static-1.12468",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11443",
  "react-codemirror": "/react-codemirror/static-1.10637",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9898",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15322",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14850",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7616",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3023",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.277",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.395",
  "slack-ui-library": "/slack-ui-library/static-1.10403",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35793",
  "sales-views-client-types": "/sales-views-client-types/static-1.4269",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3603",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12360",
  "content-media-compositions": "/content-media-compositions/static-2.16367",
  "media-bridge-lib": "/media-bridge-lib/static-1.18948",
  "trellis-story-utils": "/trellis-story-utils/static-1.4526",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5931",
  "FileManagerImages": "/FileManagerImages/static-1.36810",
  "video-components": "/video-components/static-1.13318",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4547",
  "video-embed": "/video-embed/static-1.35807",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8713",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28596",
  "ContentData": "/ContentData/static-1.68478",
  "layout-data-lib": "/layout-data-lib/static-1.9768",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22151",
  "outpost": "/outpost/static-1.4192",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6591",
  "advanced-menus-core": "/advanced-menus-core/static-1.15145",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12084",
  "ExportDialog": "/ExportDialog/static-6.10399",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34082",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15144",
  "simple-menus-lib": "/simple-menus-lib/static-1.16661"
}
};
